var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamscorrect2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6474_12307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.4771 2 2 6.4771 2 12C2 17.5229 6.4772 22 12 22C17.5228 22 22 17.5227 22 12C22 6.4773 17.5228 2 12 2ZM16.7787 9.2161L12.2518 15.1116C11.8539 15.6302 11.2513 15.9485 10.5985 15.9866C10.555 15.9895 10.5111 15.9905 10.4676 15.9905C9.8607 15.9905 9.2786 15.7464 8.8529 15.3079L7.2782 13.6858C6.9896 13.3889 6.9965 12.9133 7.2938 12.6253C7.5911 12.3373 8.0663 12.345 8.3543 12.6409L9.929 14.263C10.0833 14.4212 10.2806 14.5062 10.5115 14.4896C10.7322 14.4769 10.9275 14.3734 11.0623 14.1976L15.5892 8.3021C15.8412 7.974 16.3138 7.9125 16.6405 8.1644C16.9691 8.4164 17.0311 8.887 16.7787 9.2161Z",
    fill: "#00B885"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6474_12307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamscorrect2);
export default __webpack_public_path__ + "static/media/teamscorrect2.626fd29a3060b8229f0592e50cdc706b.svg";
export { ForwardRef as ReactComponent };